import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Page = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
  color: #fff;
`;

const OnlineOrderClosed = () => {
  return (
    <Page>
      <h2 style={{ color: '#e1d6c0' }}>Online Order Pickup is closed</h2>
      <p>We are exerienced technical difficulties, please try again later.</p>
      <p>
        Return to the <Link to="/">Homepage</Link> or browse the <Link to="/menu">Menu</Link>.
      </p>
    </Page>
  );
};

export default OnlineOrderClosed;

